import { render, staticRenderFns } from "./page-header.utils.vue?vue&type=template&id=510e8f93&scoped=true"
import script from "./page-header.utils.vue?vue&type=script&lang=js"
export * from "./page-header.utils.vue?vue&type=script&lang=js"
import style0 from "./page-header.utils.vue?vue&type=style&index=0&id=510e8f93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e8f93",
  null
  
)

export default component.exports